<template>
	<div class="text-left">
		<v-card elevation="0">
			<v-row>
				<v-col :cols="6">
					<h1>User Summary</h1>
					<v-simple-table>
						<template v-slot:default>
							<tbody>
								<tr>
									<td class="text-left">User Id</td>
									<td>{{userInfo.userUuid}}</td>
									<td><v-icon
                small
                class="mr-2"
                @click="copyToClipboard(userInfo.userUuid)"
              >
							mdi-content-copy
              </v-icon></td>
								</tr>
								<tr>
									<td class="text-left">User Name</td>
									<td>{{userInfo.userName}}</td>
									<td></td>
								</tr>
								<tr>
									<td class="text-left">Email</td>
									<td>{{userInfo.email}}</td>
									<td></td>
								</tr>
								<tr>
									<td class="text-left">First Name</td>
									<td>{{userInfo.firstName}}</td>
									<td></td>
								</tr>
								<tr>
									<td class="text-left">Last Name</td>
									<td>{{userInfo.lastName}}</td>
									<td></td>
								</tr>
								<tr>
									<td class="text-left">Organization</td>
									<td>{{userInfo.organization}}</td>
									<td></td>
								</tr>
								<tr>
									<td class="text-left">Last Login Date</td>
									<td>{{getFormattedDate(lastLoginDate)}}</td>
									<td></td>
								</tr>
								<tr>
									<td class="text-left">Last Password Changed Date</td>
									<td>{{getFormattedDate(lastPasswordChangedDate)}}</td>
									<td></td>
								</tr>
								<tr>
									<td class="text-left">Failed Password Count</td>
									<td>{{failedPasswordAttemptCount}}</td>
									<td></td>
								</tr>
							</tbody>
						</template>
					</v-simple-table>
				</v-col>
				<v-col :cols="6">
					<h1>Edit User</h1>
					<h3>Subscriptions</h3>
					<v-container row>
						<v-checkbox
							v-model="subscriptions"
							label="Email"
							value="Email"
						></v-checkbox>
						<v-checkbox
							v-model="subscriptions"
							label="ListServe"
							value="ListServe"
						></v-checkbox>
					</v-container>
					<h3>Role</h3>
					<v-col
						class="d-flex"
						cols="6"
					>
						<v-container row>
							<!-- <v-select
								:items="items"
								label="Role"
								solo
								v-model="role"
							></v-select> -->
							<v-checkbox
								v-model="accountIsResearcherAdmin"
								label="Researcher Admin"
							></v-checkbox>
							<v-checkbox
								v-model="accountIsApiAccess"
								label="API Access"
							></v-checkbox>
						</v-container>
					</v-col>
					<h3>Lock/Unlock User</h3>
					<v-container fluid>
						<v-checkbox
							v-model="lockedOut"
							label="Is User Locked"
						></v-checkbox>
					</v-container>
					<v-container row>
						<v-btn class="btn-default" text @click="saveData" :loading="isSaving">Save</v-btn>
						<v-btn class="btn-default" text @click="onOpenDelete()"><v-icon >delete</v-icon>Delete User</v-btn>
					</v-container>
				</v-col>
			</v-row>
			<v-row v-show="studyHeaders.length !== 0" class="track-respondents-table-container">
				<v-col :cols="12">
					<h1>User's Studies</h1>
					<br/>
					<v-data-table
						:headers="studyHeaders"
						:items="userStudies"
						item-key="studyId"
						class="elevation-1"
						:items-per-page="5"
					>
						<template v-for="h in studyHeaders" v-slot:[`header.${h.value}`]="{ header }">
							<span :key="h.value" class="columnTitleText" tabIndex="0" v-on:keyup.enter="(e) => e.target.click()">{{h.text}}</span>
						</template>
						<template v-slot:[`item.actions`]="{ item }">
							<v-icon
								small
								class="mr-2"
								@click="openDetails(item)"
							>
								mdi-account-details
							</v-icon>
						</template>
					</v-data-table>
				</v-col>
				<!-- <div class="pagination-container">
					<v-row>
						<v-col :cols="2">
							<v-text-field
								:value="itemsPerPage"
								label="Items per page"
								type="number"
								min="1"
								max="15"
								@input="itemsPerPage = parseInt($event, 10)"
							></v-text-field>
						</v-col>
						<v-col :cols="10">
							<v-pagination
								v-model="page"
								:length="pageCount"
							></v-pagination>
						</v-col>
					</v-row>
				</div> -->
			</v-row>
			<br>
			<v-divider></v-divider>
			<v-card-actions>
				<v-btn class="btn-default" @click="impersonate" text>Impersonate</v-btn>
				<v-spacer></v-spacer>
				<v-btn class="btn-default" text @click="$emit('backToSearch')">Back To Search</v-btn>
			</v-card-actions>
			<!-- to see the whole user object -->
			<!-- <p>{{userInfo}}</p> -->
		</v-card>
		<!-- Delete confirmation pop up -->
		<foe-dialog
      v-model="showDeleteDialog"
			:dialogW="showDeleteDialog"
      persistent
      max-width="600"
			class="delete-dialog"
    >
      <v-card class="delete-confirm-card">
        <v-card-title class="headline">
          Confirm Delete User Account
        </v-card-title>
        <v-card-text>
					<p class="p2 left-align">
						Are you sure you want to delete this user?
						<strong>This action cannot be undone.</strong> Proceed?
					</p>
				</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
						ref="firstFocusable"
            text
						class="btn-default"
            @click="showDeleteDialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            text
						:loading="isDeleting"
						class="btn-default"
            @click="onDelete()"
          >
            <v-icon>delete</v-icon>Delete User
          </v-btn>
        </v-card-actions>
      </v-card>
    </foe-dialog>
	</div>
</template>

<script>
import { researcherApiService } from '@/services/researcherApiService';
import { authService } from '@/services/authService';
import { utilityService } from '@/services/utilityService.js';
import { Roles } from '@/common/Roles.js';

export default {
	name: 'userDetails',
	props: {
		userInfo: Object
	},
	data: () => ({
		subscriptions: [],
		role: '',
		items: ['Researcher Admin', 'Researcher API'],
		userUuid: null,
		firstName: '',
		lastName: '',
		organization: '',
		phoneNumber: null,
		accountLockedOut: true,
		accountLastActivityDate: null,
		accountLastLoginDate: null,
		accountLastPasswordChangedDate: null,
		accountLastLockoutDate: null,
		accountFailedPasswordAttemptCount: null,
		accountFailedPasswordAttemptWindowStart: null,
		loadedAccountLockedOut: null,
		accountIsResearcherAdmin: false,
		accountIsApiAccess: false,
		userStudies: [],
		isSaving: false,
		isDeleting: false,
		showDeleteDialog: false
	}),
	mounted () {
		this.userUuid = this.userInfo.userUuid
		this.firstName = this.userInfo.firstName
		this.lastName = this.userInfo.lastName
		this.organization = this.userInfo.organization
		this.phoneNumber = this.userInfo.phoneNumber
		if (this.userInfo.subbedEmailNotifications) {
			this.subscriptions.push('Email')
		}
		if (this.userInfo.subbedListServ) {
			this.subscriptions.push('ListServe')
		}

		// Load the user's account info
		if (this.userUuid) {
			researcherApiService.getUserAccountInfo(this.userUuid).then(response => {
				this.loadedAccountLockedOut = response.data.userAccount.lockedOut;
				this.accountLockedOut = response.data.userAccount.lockedOut;
				this.accountLastActivityDate = response.data.userAccount.lastActivityDate;
				this.accountLastLoginDate = response.data.userAccount.lastLoginDate;
				this.accountLastPasswordChangedDate = response.data.userAccount.lastPasswordChangedDate;
				this.accountLastLockoutDate = response.data.userAccount.lastLockoutDate;
				this.accountFailedPasswordAttemptCount = response.data.userAccount.failedPasswordAttemptCount;
				this.accountFailedPasswordAttemptWindowStart = response.data.userAccount.failedPasswordAttemptWindowStart;
				this.userStudies = response.data.userStudies;
				this.accountIsResearcherAdmin = response.data.roles.some(role => role.toLowerCase() === Roles.Admin.toLowerCase());
				this.accountIsApiAccess = response.data.roles.some(role => role.toLowerCase() === Roles.ApiAccess.toLowerCase());
			});
		}
	},
	methods: {
		saveData () {
			this.isSaving = true;
			const me = this;
			const userDetails = {};
			userDetails.userUuid = this.userUuid;
			userDetails.roles = [];
			if (this.accountIsResearcherAdmin) {
				userDetails.roles.push(Roles.Admin);
			}
			if (this.accountIsApiAccess) {
				userDetails.roles.push(Roles.ApiAccess);
			}
			if (this.subscriptions.includes('Email')) {
				userDetails.isSubbedEmailNotifications = true
			} else {
				userDetails.isSubbedEmailNotifications = false
			}
			if (this.subscriptions.includes('ListServe')) {
				userDetails.isSubbedListServ = true
			} else {
				userDetails.isSubbedListServ = false
			}

			researcherApiService.adminUpdateUserInfo(userDetails.userUuid, userDetails)
				.then(function (response) {
					me.isSaving = false;
					me.$store.dispatch('changeUpdateStatus', { status: 'user-details-update-success' });
				})
				.catch(function (e) {
					me.isSaving = false;
					me.$store.dispatch('changeUpdateStatusWithMessage', { status: 'user-details-update-fail', message: 'user update failed' });
				});

			// Update the lock status if it was changed
			if (this.loadedAccountLockedOut !== this.accountLockedOut) {
				authService.updateLockStatus(this.userUuid, this.accountLockedOut)
					.then(function (response) {
						if (response && response.data) {
							me.$store.dispatch('changeUpdateStatusWithMessage', { status: 'generic-success', message: `User ${me.userInfo.userName}'s lock status successfully updated` });
						} else {
							me.$store.dispatch('changeUpdateStatusWithMessage', { status: 'generic-error', message: `There was an error updating the user ${me.userInfo.userName}'s lock status` });
						}
					}).catch(error => {
						me.$store.dispatch('changeUpdateStatusWithMessage', { status: 'generic-error', message: `There was an error updating the user ${me.userInfo.userName}'s lock status` });
					});
			}
		},
		async impersonate () {
			var impersonatedUserUuid = this.userUuid;
			this.$store.dispatch('impersonateUser', impersonatedUserUuid).then(() => {
				this.$router.push({ name: 'Landing' });
			});
		},
		copyToClipboard(value) {
			const me = this;
			utilityService.copyToClipboard(value)
        .then(function() {
            me.$store.dispatch('changeUpdateStatusWithMessage', { status: 'generic-success', message: `User id copied to clipboard` });
        })
        .catch(function(err) {
            me.$store.dispatch('changeUpdateStatusWithMessage', { status: 'generic-error', message: `Copy to clipboard failed` });
        });
		},
		getFormattedDate (date) {
			if (date && date.length) {
				return utilityService.formatDate(date)
			}
			return 'N/A';
		},
		onOpenDelete () {
			this.showDeleteDialog = true;
		},
		onDelete () {
			const me = this;
			this.isDeleting = true;

			researcherApiService.deleteResearcher(this.userUuid)
				.then(function (response) {
					if (response && response.data) {
						me.isDeleting = false;
						// Show a success message
						me.$store.dispatch('changeUpdateStatusWithMessage', {
							status: 'generic-success',
							message: `The user ${me.userInfo.userName} was successfully deleted`
						});
						// Return to the user index page
						me.$emit('backToSearch');
					}
				}).catch(function (response) {
					me.isDeleting = false;

					if (response.response.status >= 400 && response.response.status < 500) {
						me.showDeleteDialog = false;
						// Show an error message
						me.$store.dispatch('changeUpdateStatusWithMessage', {
							status: 'generic-error',
							message: `User could not be deleted: ${response.response.data.messages[0]}`
						});
					} else if (response.response.status >= 500) {
						me.showDeleteDialog = false;
						// Show an error message
						me.$store.dispatch('changeUpdateStatusWithMessage', {
							status: 'generic-error',
							message: `There was an error deleting user ${me.userInfo.userName}`
						});
					}
				});
		}
	},
	computed: {
		studyHeaders: function () {
			return [
				{ text: 'StudyId', value: 'studyId', hover: '', class: 'data-table-header' },
				{ text: 'StudyTool', value: 'studyTool', hover: '', class: 'data-table-header' },
				{ text: 'Version', value: 'version', hover: '', class: 'data-table-header' },
				{ text: 'PrimaryEmail', value: 'primaryEmail', hover: '', class: 'data-table-header', sortable: true }
				// { text: 'Study Details', value: 'actions', hover: '', class: 'data-table-header', sortable: false }
			]
		},
		lockedOut: {
			get: function () {
				return this.accountLockedOut;
			},
			set: function (value) {
				this.accountLockedOut = value;
			}
		},
		lastActivityDate: function () {
			return this.accountLastActivityDate;
		},
		lastLoginDate: function () {
			// Used as an example
			// var test = '2022-02-22T16:00:48.737Z'
			// return test;
			return this.accountLastLoginDate;
		},
		lastPasswordChangedDate: function () {
			return this.accountLastPasswordChangedDate;
		},
		lastLockoutDate: function () {
			return this.accountLastLockoutDate;
		},
		failedPasswordAttemptCount: function () {
			return this.accountFailedPasswordAttemptCount;
		},
		failedPasswordAttemptWindowStart: function () {
			return this.failedPasswordAttemptWindowStart;
		}
	}
}
</script>

<style>

</style>
